$(document).ready(function () {
  (function ($) {

    // var mediaQueryLg = window.matchMedia("(min-width: 768px)");
    // // Button product tile card
    // if ($('.product-tile.quick-buy')) {

    //   if (mediaQueryLg.matches) {
          
    //     $('.product-tile.quick-buy').on('mouseenter', function() {
    //       $(this).find('.product-tile:has(.content)').fadeTo(150,0);
    //       $(this).find('.description').fadeTo(150,0);
    //       $(this).find('.quick-buy-product-form').slideDown();
    //     })
    //     $('.product-tile.quick-buy').on('mouseleave', function() {
    //       $(this).find('.quick-buy-product-form').slideUp();
    //       $(this).find('.product-tile:has(.content)').fadeTo(150,1);
    //       $(this).find('.description').fadeTo(150,1);
    //     })

    //   }

    // }

    $(".mega-menu .owl-carousel").owlCarousel({
      loop: true,
      margin: 25,
      stagePadding: 20,
     nav: true,
      dots: false,
      autoplay: true,
      items: 2.8,
      responsive: {
        1200: {
          items: 3.4,
          margin: 40,
        },
        1400: {
           items: 4.2,
           items: 4.2,
           margin: 40,
         },
         2000: {
           items: 5.4,
           margin: 40,
         },
       },
     });
    

    $(".slider-posts .owl-carousel").owlCarousel({
      loop: true,
      margin: 20,
      stagePadding: 15,
      nav: true,
      dots: false,
      autoplay: true,
      items: 1.15,
      responsive: {
        992: {
          items: 1.7,
          center: true,
          margin: 30,
        },
        1200: {
          items: 1.3,
          center: true,
          margin: 30,
        },
        1400: {
          items: 1.6,
          center: true,
          margin: 30,
        },
        2000: {
          items: 2.2,
          center: true,
          margin: 40,
        },
      },
    });
  })(jQuery);
});

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);